export const REVALIDATE = 600

export const SITE_URL = 'https://startupcraft.io'

export const SITE_NAME = 'StartupCraft'

export const SITE_TAGLINE =
  'StartupCraft — Custom Software & AI Development Agency in Sydney'

// Meta-description string (≤160 chars, the repo-wide rule). The fuller
// canonical positioning lives in SITE_POSITIONING — schema fields have no
// length budget, meta descriptions do.
export const SITE_DESCRIPTION =
  'Custom software and AI development agency in Sydney. We build the operational platforms businesses run on — 120+ products, senior engineers only.'

// Canonical positioning, agreed across Clutch / Crunchbase / LinkedIn / site.
// "Since 2015" rather than a hardcoded decade: the founding year is what has
// to match across the four properties, and it never goes stale.
export const SITE_POSITIONING =
  'StartupCraft is a custom software and AI development agency in Sydney. We build the operational platforms businesses run on, and increasingly the AI that runs inside them. Since 2015, 120+ products, senior engineers only. Every engagement opens with a paid discovery.'

export const PHONE_MASK = [
  '(',
  /[1-9]/,
  /\d/,
  /\d/,
  ')',
  ' ',
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
]

export const DEMO_LINK = 'https://app.demo.startupcraft.io/'

export const HEADER_HEIGHT = { min: 76, max: 76 }
